module.exports = __webpack_public_path__ + "img/metamask-fox-wordmark-horizontal.e2705059.svg";